// extracted by mini-css-extract-plugin
export default {"firstColumn":"LocationRolesList_firstColumn__KzaBJ","checkboxWrapper":"LocationRolesList_checkboxWrapper__iPrYH","titleWrapper":"LocationRolesList_titleWrapper__WlWQm"};